// API
import axios from 'axios'
import { LOGOUT } from '../redux/actions/authActions';
import { REMOVE_PERMISSIONS } from '../redux/actions/permissionsActions';
import { store } from '../redux/store'

const host = window.location.host;

let baseURL = ''
if (host === 'localhost:3000' || host === '127.0.0.1:3000') {
    baseURL = 'http://localhost:8000/'
} else if (host === 'uat-emanage.axiumgenie.com') {
    baseURL = 'https://uat-emanage-api.axiumgenie.com/'
} else if (host === 'emanage.axiumgenie.com') {
    baseURL = 'https://emanage-api.axiumgenie.com/'
}

const API = axios.create({
    baseURL: baseURL,
    // withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
})

/**
 * Unwraps Blob error responses into JSON.
 * Needed because `responseType: "blob"` requests return error bodies
 * as Blobs too, breaking `error.response.data` access. If the Blob's
 * content-type is JSON, parses it and replaces `error.response.data`.
 * Leaves data untouched if parsing fails.
 */
API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response } = error;
        if (response && response.data instanceof Blob && response.data.type.includes("application/json")) {
            const text = await response.data.text();
            try {
                error.response.data = JSON.parse(text);
            } catch {
                // leave as-is if not valid JSON
            }
        }
        return Promise.reject(error);
    }
);

/**
 * Global 401 handler: clears auth state and reloads the app.
 * Note: assumes `error.response` exists — network/CORS errors will throw.
 */
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('device_token_stored');
            store.dispatch({ type: REMOVE_PERMISSIONS });
            store.dispatch({ type: LOGOUT });
            window.location.reload();
        }
        throw error
    }
);

/**
 * Extracts a filename from a Content-Disposition header.
 *
 * @param {string} contentDispositionHeader
 * @param {string} fallbackName
 * @returns {string}
 */
export const getFilenameFromHeader = (
    contentDispositionHeader,
    fallbackName = 'downloaded_file'
) => {
    if (!contentDispositionHeader) return fallbackName;

    const match =
        contentDispositionHeader.match(/filename\*=utf-8''([^;\n]+)/i) ??
        contentDispositionHeader.match(/filename=([^;\n]+)/i);

    if (!match?.[1]) return fallbackName;

    const filename = match[1].trim().replace(/^["']|["']$/g, '');

    try {
        return decodeURIComponent(filename);
    } catch {
        return filename;
    }
};

/**
 * Downloads a Blob as a file in the browser.
 *
 * @param {Blob} data - The file data returned by the server.
 * @param {string} filename - The filename to use for the downloaded file.
 * @returns {void}
 */
export const downloadResponseFile = (data, filename) => {
    const url = URL.createObjectURL(data);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
};

export default API